/**
 * Created by swandelow on 01/08/18.
 */

import {Injectable} from "@angular/core";
import {SidebarService} from "../sidebar/sidebar.service";
import {Subject} from "rxjs/Subject";

@Injectable()
export class NavigationService {

    private readonly COMPANY_OID_PLACEHOLDER = /\${companyOid}/;

    urls = {
        availability: "company/${companyOid}/availability",
        additionalPrice: "company/${companyOid}/additionalPrice",
        alertEmail: "company/${companyOid}/alertEmail",
        ageRange: "company/${companyOid}/agerange",
        bookings: "booking",
        company: "company/${companyOid}",
        companyBookings: "company/${companyOid}/booking",
        companyRequest: "companyRequest",
        contact: "company/${companyOid}/contact",
        contract: "company/${companyOid}/contract",
        fleet: "company/${companyOid}/fleet",
        carTemplate: "company/${companyOid}/carTemplate",
        holiday: "company/${companyOid}/holiday",
        home: "company/${companyOid}/home",
        impersonate: "impersonate",
        insurancePrice: "company/${companyOid}/insurancePrice",
        loadFleet: "loader/new",
        logout: "logout",
        markup: "markup",
        moderate: "moderate",
        moderateCarTemplate: "moderateCarTemplate",
        modificationPolicies: "company/${companyOid}/modificationpolicies",
        newCompany: "company/new",
        oneWay: "company/${companyOid}/oneway",
        opaqueRates: "company/${companyOid}/opaquerate",
        pickupPoints: "company/${companyOid}/pickupPoint",
        pickupPointFee: "company/${companyOid}/pickupPointFee",
        pointsOfSale: "company/${companyOid}/pointOfSale",
        priceAndAvailability: "company/${companyOid}/priceAndAvailability",
        rangeDefinition: "company/${companyOid}/rangedefinition",
        rate: "company/${companyOid}/rate",
        restrictions: "company/${companyOid}/restrictions",
        reviews: "company/${companyOid}/reviews",
        specialOffers: "company/${companyOid}/specialoffer"
    };
    
    constructor(private sidebarService: SidebarService) {}

    getHref(section: string, companyOid: number): string {
        let url = this.urls[section];
        let hasCompanyOidPlaceholder = this.COMPANY_OID_PLACEHOLDER.test(url);
        if(hasCompanyOidPlaceholder) {
            if(!!companyOid) {
                url = url.replace("${companyOid}", companyOid);
            } else {
                throw new Error("Undefined companyOid while trying to get url for navigation");
            }
        }
        return url;
    }

    getNavConfig(): any {
        return this.sidebarService.getConfig();
    }

    isActiveMenu(name: string): boolean {
        let navigationValue = this.sidebarService.sidebar;
        switch (name) {
            case "company":
                return ['company', 'pointOfSale', 'contract', 'emailAlert', 'pickupPoint', 'holiday'].indexOf(navigationValue) > -1;
            case "generalConditions":
                return ['fee', 'rangeDefinition', 'modificationPolicies', 'ageRange', 'restrictions', 'oneWay', 'insurancePrice', 'additionalPrice'].indexOf(navigationValue) > -1;
            case "priceAndAvailability":
                return ['priceAndAvailability', 'modifyRates', 'modifyAvailability', 'specialOffer'].indexOf(navigationValue) > -1;
            case "bookings":
            case "reviews":
            case "contact":
            case "fleet":
                return name === navigationValue;
            default:
                return false;
        }
    }

    getSectionSubject(): Subject<string> {
        return this.sidebarService.getSidebarSubject();
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/root/sara-header/navigation.service.ts